import React, { useContext } from "react";
import Context from "../context";
import FilterMenu from "./filterMenu";
import Search from "../../../components/searchField";

const HeaderView = () => {
    const context = useContext(Context);

    return(
        <div className="row">
            <div className="row">
                <div className="col-md-6">
                    <h6 className="text-white text-capitalize ps-3">
                        {context.state.search_type === '' ? "ALL TRADESPERSONS" : "TRADESPERSONS - "+context.state.search_type}
                    </h6> 
                </div>
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-11">
                            <Search
                                onSearch = {(search_text) => {
                                    context.dispatch({ type: "SET_SERACH_TEXT", serach_text: search_text });
                                }}
                            />
                        </div>
                        <div className="col-md-1">
                            <FilterMenu/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeaderView;